import ConsumerScanPanel from './consumerScanPanel.container';

export default ConsumerScanPanel;